<div class="drawer-overlay" (click)="onCancel()">
  <div class="drawer" (click)="onWindowClick($event)">
    <div class="drawer-header">
      <h3>{{ 'COMMON.ADD_FILTER.PLURAL' | translate }}</h3>
    </div>

    <div class="drawer-body">
      <ul>
        <ng-container *ngFor="let option of filterOptions">
          <ng-container *ngIf="!option.attributeDefinitionId" [ngSwitch]="option.staticPropertyName">
            <li class="filter-item" *ngSwitchCase="'Date'"><ng-container [ngTemplateOutlet]="dateFilter"></ng-container></li>
            <li class="filter-item" *ngSwitchCase="'RegionDistrict'"><ng-container [ngTemplateOutlet]="regionFilter"></ng-container></li>
            <li class="filter-item" *ngSwitchCase="'GeoSubGeoRegion'"><ng-container [ngTemplateOutlet]="geoRegionFilter"></ng-container></li>
            <li class="filter-item" *ngSwitchCase="'UserType'"><ng-container [ngTemplateOutlet]="userTypeFilter"></ng-container></li>
            <li class="filter-item" *ngSwitchCase="'Users'"><ng-container [ngTemplateOutlet]="usersFilter"></ng-container></li>
            <li class="filter-item" *ngSwitchCase="'ValidationStatus'"><ng-container [ngTemplateOutlet]="validationStatusFilter"></ng-container></li>
            <li class="filter-item" *ngSwitchCase="'ReviewStatus'"><ng-container [ngTemplateOutlet]="reviewStatusFilter"></ng-container></li>
            <li class="filter-item" *ngSwitchCase="'AuditStatus'"><ng-container [ngTemplateOutlet]="auditStatusFilter"></ng-container></li>
            <li class="filter-item" *ngSwitchCase="'Tag'"><ng-container [ngTemplateOutlet]="tagFilter"></ng-container></li>
            <li class="filter-item" *ngSwitchCase="'Tariff'"><ng-container [ngTemplateOutlet]="tariffFilter"></ng-container></li>
            <li class="filter-item" *ngSwitchCase="'SltStatus'"><ng-container [ngTemplateOutlet]="sltStatusFilter"></ng-container></li>
            <li class="filter-item" *ngSwitchCase="'UseOfPremises'"><ng-container [ngTemplateOutlet]="useOfPremisesFilter"></ng-container></li>
            <li class="filter-item" *ngSwitchCase="'DirectConnection'"><ng-container [ngTemplateOutlet]="directConnectionFilter"></ng-container></li>
          </ng-container>

          <li class="filter-item" *ngIf="option.attributeDefinition && isOptionFilter(option)">
            <ng-container [ngTemplateOutlet]="optionFilter" [ngTemplateOutletContext]="{ attr: option.attributeDefinition }"></ng-container>
          </li>
          <li class="filter-item" *ngIf="option.attributeDefinition && fieldType(option) === 'DateTime'">
            <ng-container [ngTemplateOutlet]="dynamicDateFilter" [ngTemplateOutletContext]="{ attr: option.attributeDefinition }"></ng-container>
          </li>
        </ng-container>
      </ul>
    </div>

    <div class="drawer-footer">
      <button class="cancel-btn" (click)="onCancel()">{{ 'COMMON.CANCEL' | translate }}</button>
      <button class="add-filter-btn" (click)="onAddFilter()">{{ 'COMMON.ADD_FILTER.SINGLE' | translate }}</button>
    </div>
  </div>
</div>

<ng-template #filterHeader let-key="key" let-title="title">
  <div class="filter-header" (click)="toggleFilter(key)">
    <div class="img-title-container">
      <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M7.29167 9.99917L9.09725 11.8742L12.7083 8.12417M3.125 10.8325V6.4459C3.125 5.4425 3.72492 4.53633 4.64863 4.14445L9.02367 2.28839C9.64767 2.02366 10.3523 2.02366 10.9763 2.28839L15.3513 4.14445C16.2751 4.53633 16.875 5.4425 16.875 6.4459V10.8325C16.875 14.6294 13.7969 17.7075 10 17.7075C6.20304 17.7075 3.125 14.6294 3.125 10.8325Z"
          [attr.stroke]="openedFilters.includes(key) ? 'var(--primary-color)' : '#17171A'" stroke-opacity="0.9" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
      </svg>
      <span class="filter-title" [class.date-open]="openedFilters.includes(key)">{{ title | translate }}</span>
    </div>
    <img src="../../../assets/icons/gray-arrow-down.svg" alt="Dropdown" [class.open]="openedFilters.includes(key)" />
  </div>
</ng-template>

<ng-template #dateFilter>
  <ng-container [ngTemplateOutlet]="filterHeader" [ngTemplateOutletContext]="{ key: 'date', title: 'COMMON.DATE' }"></ng-container>
  <div *ngIf="openedFilters.includes('date')" class="date-filter-section">
    <div class="filter-row">
      <select [(ngModel)]="filter.filterParams.dateTypeString" class="full-width" (change)="onDateTypeChange()">
        <option *ngFor="let t of dateTypes" [value]="t.label">{{ t.translation | translate }}</option>
      </select>
    </div>
    <div class="filter-row">
      <button class="full-width">
        <span>{{ 'COMMON.DATE_FROM' | translate }}: </span>
        <input type="date" [(ngModel)]="filter.filterParams.dateFrom" />
      </button>
      <button class="full-width">
        <span>{{ 'COMMON.DATE_TO' | translate }}: </span>
        <input type="date" [(ngModel)]="filter.filterParams.dateTo" />
      </button>
    </div>
  </div>
</ng-template>

<ng-template #regionFilter>
  <ng-container [ngTemplateOutlet]="filterHeader" [ngTemplateOutletContext]="{ key: 'region', title: 'COMMON.BU.SINGLE' }"></ng-container>
  <div *ngIf="openedFilters.includes('region')" class="filter-section">
    <div class="region-area-container">
      <div class="region-column">
        <div class="search-row">
          <input type="text" [placeholder]="'COMMON.SEARCH' | translate" [(ngModel)]="filter.filterParams.regionSearchText" />
        </div>
        <div class="region-list">
          <div *ngFor="let region of filteredRegions" class="region-item">
            <div class="region-header" [class.selected]="filter.filterParams.selectedRegionModel?.id === region.id" (click)="selectRegion(region)">
              <span>{{ region.name }}</span>
            </div>
          </div>
        </div>
      </div>
      <div *ngIf="filter.filterParams.selectedRegionModel" class="area-column">
        <div class="search-row">
          <input type="text" [placeholder]="'COMMON.SEARCH' | translate" [(ngModel)]="filter.filterParams.areaSearchText" (ngModelChange)="updateAreas()" />
        </div>
        <div class="area-list">
          <div *ngFor="let area of areas" class="area-item">
            <input type="checkbox" [checked]="isAreaSelected({ id: area.id, name: area.name })"
              (change)="onAreaSelect({ id: area.id, name: area.name }, $event)" />
            <span>{{ area.name }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #geoRegionFilter>
  <ng-container [ngTemplateOutlet]="filterHeader" [ngTemplateOutletContext]="{ key: 'geo', title: 'COMMON.BU.SINGLE' }"></ng-container>
  <div *ngIf="openedFilters.includes('geo')" class="filter-section">
    <div class="region-area-container">
      <div class="region-column">
        <div class="search-row">
          <input type="text" [placeholder]="'COMMON.SEARCH' | translate" [(ngModel)]="filter.filterParams.geoSearchText" />
        </div>
        <div class="region-list">
          <div *ngFor="let geo of filteredGeoRegions" class="region-item">
            <div class="region-header" [class.selected]="filter.filterParams.selectedGeoRegionModel?.id === geo.id" (click)="selectGeoRegion(geo)">
              <span>{{ geo.name }}</span>
            </div>
          </div>
        </div>
      </div>
      <div *ngIf="filter.filterParams.selectedGeoRegionModel" class="area-column">
        <div class="search-row">
          <input type="text" [placeholder]="'COMMON.SEARCH' | translate" [(ngModel)]="filter.filterParams.subGeoSearchText" (ngModelChange)="updateSubGeoRegions()" />
        </div>
        <div class="area-list">
          <div *ngFor="let sg of subGeoRegions" class="area-item">
            <input type="checkbox" [checked]="isSubGeoSelected({ id: sg.id, name: sg.name })"
              (change)="onSubGeoSelect({ id: sg.id, name: sg.name }, $event)" />
            <span>{{ sg.name }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #userTypeFilter>
  <ng-container [ngTemplateOutlet]="filterHeader" [ngTemplateOutletContext]="{ key: 'user-type', title: 'COMMON.USER.TYPE.TITLE' }"></ng-container>
  <div *ngIf="openedFilters.includes('user-type')" class="user-type-filter-section">
    <label *ngFor="let option of userTypes">
      <input type="radio" name="userType" [checked]="filter.filterParams.userType === option.value" (change)="onSelectUserType(option.value)" />
      <span class="option">{{ option.translation | translate }}</span>
    </label>
  </div>
</ng-template>

<ng-template #usersFilter>
  <ng-container [ngTemplateOutlet]="filterHeader" [ngTemplateOutletContext]="{ key: 'users', title: 'COMMON.USER.PLURAL' }"></ng-container>
  <div *ngIf="allUsers.length > 0 && openedFilters.includes('users')" class="users-filter-section">
    <input type="text" class="user-search-input" [placeholder]="'COMMON.SEARCH' | translate" [(ngModel)]="filter.filterParams.searchUsersText" />
    <label *ngFor="let user of filteredUsers">
      <input type="checkbox" [checked]="isUserSelected(user)" (change)="onSelectUser(user, $event)" />
      <span class="option">{{ user.name }}</span>
    </label>
  </div>
</ng-template>

<ng-template #validationStatusFilter>
  <ng-container [ngTemplateOutlet]="filterHeader" [ngTemplateOutletContext]="{ key: 'validation-status', title: 'COMMON.VALIDATION_STATUS' }"></ng-container>
  <div *ngIf="openedFilters.includes('validation-status')" class="validation-status-filter-section">
    <label *ngFor="let option of validationStatuses">
      <input type="checkbox" [checked]="isValidationStatusSelected(option.value)" (change)="onValidationStatusChange(option.value, $event)" />
      <span class="option">{{ option.translation | translate }}</span>
    </label>
  </div>
</ng-template>

<ng-template #reviewStatusFilter>
  <ng-container [ngTemplateOutlet]="filterHeader" [ngTemplateOutletContext]="{ key: 'review-status', title: 'COMMON.REVIEW_STATUS' }"></ng-container>
  <div *ngIf="openedFilters.includes('review-status')" class="review-status-filter-section">
    <label *ngFor="let option of reviewStatuses">
      <input type="radio" name="reviewStatus" [value]="option.value" [(ngModel)]="filter.filterParams.reviewStatus" />
      <span class="option">{{ option.translation | translate }}</span>
    </label>
  </div>
</ng-template>

<ng-template #auditStatusFilter>
  <ng-container [ngTemplateOutlet]="filterHeader" [ngTemplateOutletContext]="{ key: 'audit-status', title: 'COMMON.AUDIT_STATUS' }"></ng-container>
  <div *ngIf="openedFilters.includes('audit-status')" class="review-status-filter-section">
    <label *ngFor="let option of auditStatuses">
      <input type="radio" name="auditStatus" [value]="option.value" [(ngModel)]="filter.filterParams.auditStatus" />
      <span class="option">{{ option.translation | translate }}</span>
    </label>
  </div>
</ng-template>

<ng-template #tagFilter>
  <ng-container [ngTemplateOutlet]="filterHeader" [ngTemplateOutletContext]="{ key: 'tag', title: 'COMMON.TAG.TITLE' }"></ng-container>
  <div *ngIf="openedFilters.includes('tag')" class="tag-filter-section">
    <label *ngFor="let option of tagOptions">
      <input type="radio" name="tag" [value]="option.value" [(ngModel)]="filter.filterParams.tag" />
      <span class="option">{{ option.translation | translate }}</span>
    </label>
  </div>
</ng-template>

<ng-template #tariffFilter>
  <ng-container [ngTemplateOutlet]="filterHeader" [ngTemplateOutletContext]="{ key: 'tariff', title: 'COMMON.TARIFF.SINGLE' }"></ng-container>
  <div *ngIf="openedFilters.includes('tariff')" class="tag-filter-section">
    <label *ngFor="let t of tariffs">
      <input type="radio" name="tariff" [value]="t.id" [(ngModel)]="filter.filterParams.tariffId" />
      <span class="option">{{ t.name }}</span>
    </label>
  </div>
</ng-template>

<ng-template #sltStatusFilter>
  <ng-container [ngTemplateOutlet]="filterHeader" [ngTemplateOutletContext]="{ key: 'slt-status', title: 'COMMON.SLT_STATUS.SINGLE' }"></ng-container>
  <div *ngIf="openedFilters.includes('slt-status')" class="tag-filter-section">
    <label *ngFor="let s of sltOptions">
      <input type="radio" name="sltStatus" [value]="s.key" [(ngModel)]="filter.filterParams.sltStatus" />
      <span class="option">{{ s.value }}</span>
    </label>
  </div>
</ng-template>

<ng-template #useOfPremisesFilter>
  <ng-container [ngTemplateOutlet]="filterHeader" [ngTemplateOutletContext]="{ key: 'use-of-premises', title: 'COMMON.USE_OF_PREMISES' }"></ng-container>
  <div *ngIf="openedFilters.includes('use-of-premises')" class="tag-filter-section">
    <label *ngFor="let u of useOfPremisesOptions">
      <input type="radio" name="useOfPremises" [value]="u.value" [(ngModel)]="filter.filterParams.useOfPremises" />
      <span class="option">{{ u.translation | translate }}</span>
    </label>
  </div>
</ng-template>

<ng-template #directConnectionFilter>
  <ng-container [ngTemplateOutlet]="filterHeader" [ngTemplateOutletContext]="{ key: 'direct-connection', title: 'CUSTOMERS.DIRECT' }"></ng-container>
  <div *ngIf="openedFilters.includes('direct-connection')" class="tag-filter-section">
    <label>
      <input type="checkbox" [(ngModel)]="filter.filterParams.showDirectConnection" />
      <span class="option">{{ 'CUSTOMERS.DIRECT' | translate }}</span>
    </label>
  </div>
</ng-template>

<ng-template #optionFilter let-attr="attr">
  <ng-container [ngTemplateOutlet]="filterHeader" [ngTemplateOutletContext]="{ key: 'attr-' + attr.id, title: attr.label }"></ng-container>
  <div *ngIf="openedFilters.includes('attr-' + attr.id)" class="validation-status-filter-section">
    <label *ngFor="let option of attr.optionDefinitions">
      <input type="checkbox" [checked]="isOptionSelected(attr.id, option.id)" (change)="onOptionChange(attr.id, option.id, $event)" />
      <span class="option">{{ option.value }}</span>
    </label>
  </div>
</ng-template>

<ng-template #dynamicDateFilter let-attr="attr">
  <ng-container [ngTemplateOutlet]="filterHeader" [ngTemplateOutletContext]="{ key: 'attr-' + attr.id, title: attr.label }"></ng-container>
  <div *ngIf="openedFilters.includes('attr-' + attr.id)" class="date-filter-section">
    <div class="filter-row">
      <button class="full-width">
        <span>{{ 'COMMON.DATE_FROM' | translate }}: </span>
        <input type="date" [value]="getDynamicDateValue(attr.id, 'from')" (change)="onDynamicDateChange(attr.id, 'from', $event)" />
      </button>
      <button class="full-width">
        <span>{{ 'COMMON.DATE_TO' | translate }}: </span>
        <input type="date" [value]="getDynamicDateValue(attr.id, 'to')" (change)="onDynamicDateChange(attr.id, 'to', $event)" />
      </button>
    </div>
  </div>
</ng-template>
